var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "01) Icons/Line/log-in"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4H19C19.55 4 20 4.45 20 5V19C20 19.55 19.55 20 19 20H17C16.45 20 16 19.55 16 19C16 18.45 16.45 18 17 18H18V6H17C16.45 6 16 5.55 16 5C16 4.45 16.45 4 17 4ZM10.3998 7.2004C10.8438 6.8694 11.4688 6.9594 11.7998 7.4004L14.7998 11.4004C15.0598 11.7464 15.0678 12.2204 14.8178 12.5754L12.0038 16.5754C11.8088 16.8524 11.4998 17.0004 11.1848 17.0004C10.9868 17.0004 10.7858 16.9414 10.6108 16.8184C10.1588 16.5004 10.0498 15.8764 10.3678 15.4244L12.0858 12.9824C12.0723 12.9837 12.0596 12.9875 12.047 12.9913C12.0316 12.9958 12.0163 13.0004 11.9998 13.0004H3.99976C3.44776 13.0004 2.99976 12.5524 2.99976 12.0004C2.99976 11.4474 3.44776 11.0004 3.99976 11.0004H11.9998H12.0008L10.1998 8.5994C9.86876 8.1584 9.95776 7.5314 10.3998 7.2004Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_735_12675",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 18,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4H19C19.55 4 20 4.45 20 5V19C20 19.55 19.55 20 19 20H17C16.45 20 16 19.55 16 19C16 18.45 16.45 18 17 18H18V6H17C16.45 6 16 5.55 16 5C16 4.45 16.45 4 17 4ZM10.3998 7.2004C10.8438 6.8694 11.4688 6.9594 11.7998 7.4004L14.7998 11.4004C15.0598 11.7464 15.0678 12.2204 14.8178 12.5754L12.0038 16.5754C11.8088 16.8524 11.4998 17.0004 11.1848 17.0004C10.9868 17.0004 10.7858 16.9414 10.6108 16.8184C10.1588 16.5004 10.0498 15.8764 10.3678 15.4244L12.0858 12.9824C12.0723 12.9837 12.0596 12.9875 12.047 12.9913C12.0316 12.9958 12.0163 13.0004 11.9998 13.0004H3.99976C3.44776 13.0004 2.99976 12.5524 2.99976 12.0004C2.99976 11.4474 3.44776 11.0004 3.99976 11.0004H11.9998H12.0008L10.1998 8.5994C9.86876 8.1584 9.95776 7.5314 10.3998 7.2004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_735_12675)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.2d4e046e9751d20412584f3a2920cc2f.svg";
export { ForwardRef as ReactComponent };